// api
import { fetchApi } from '@/api'

// actions

const restauranCategoriesALL = (context) => {
  let url = 'restaurant/categories'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      context.commit('RESTAURANT_CATEGORIES_REQUESTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restauranCateforiesForm = (context) => {
  let url = 'restaurant/categories/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_CATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restauranCategoriesCreate = (context, payload) => {
  let url = 'restaurant/categories'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('restaurantCategories', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restauranCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'restaurant/categories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_CATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const restaurantReversionDelete = (context, payload) => {
  let url = 'restaurant/reversion'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('RESTAURANT_CATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const restauranCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'restaurant/categories/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_CATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restauranCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'restaurant/categories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_CATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}
export default {
  restauranCategoriesALL,
  restauranCateforiesForm,
  restauranCategoriesCreate,
  restauranCategoriesDelete,
  restauranCategoriesShow,
  restauranCategoriesUpdate,
  restaurantReversionDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/categories/actions.js